import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export const preloadPersonalSpaceDetailsQuery: GraphQLTaggedNode = graphql`
	query preloadPersonalSpaceDetailsQuery {
		user: confluence_atlassianUser(current: true) {
			id
			confluence {
				space {
					id
					key
					dataClassificationTags
				}
			}
		}
	}
`;

export const preloadPersonalSpaceDetail = (): Promise<{
	data: unknown;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> => {
	return query({
		query: preloadPersonalSpaceDetailsQuery,
	});
};
